import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=02b94b25&scoped=true&"
import script from "./DownloadPage.vue?vue&type=script&lang=js&"
export * from "./DownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=02b94b25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b94b25",
  null
  
)

export default component.exports